'use client'
import { FC } from 'react'

import { MenuItem } from 'ui/storefront'
import { MenuStandardSlideOutMobileMenu } from 'storefront-modules/layout/Menu/MenuStandard'
import { useAppConfigContext } from '#/src/appConfig'

export interface ISlideOutMobileMenuProps {
  menuItems: MenuItem[]
}

const SlideOutMobileMenu: FC<ISlideOutMobileMenuProps> = ({ menuItems }) => {
  const appConfig = useAppConfigContext()

  return (
    <MenuStandardSlideOutMobileMenu
      menuItems={menuItems}
      paths={{
        categories: appConfig.paths.categoriesUrlPath
      }}
    />
  )
}

export default SlideOutMobileMenu
